;(function () {
	let productsGridSwiper
	let sectionResizeObserver

	const initSlider = (slider) => {
		slider.classList.add('swiper')

		const wrapper = slider.querySelector('.collection-product-list')

		if (!wrapper) return

		wrapper.classList.add('swiper-wrapper')

		const slides = slider.querySelectorAll('.collection-product-card')

		if (!slides || !slides.length) return

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})

		productsGridSwiper = new Swiper(slider, {
			loop: false,
			slidesPerView: 1.1,
			spaceBetween: 16,
			speed: 1000,
			freeMode: { enabled: true, sticky: false, momentumBounce: false },
			mousewheel: {
				forceToAxis: true,
			},
		})
	}

	const destroySlider = (section) => {
		if (!section || !section?.classList.contains('products-grid-section'))
			return

		const slider = section.querySelector('.products-grid-slider')
		const slides = section.querySelectorAll('.collection-product-card')
		const wrapper = section.querySelector('.collection-product-list')

		if (!slider || !slides || !slides.length || !wrapper) return

		slider.classList.remove('swiper')

		slides.forEach((slide) => {
			slide.classList.remove('swiper-slide')
		})

		wrapper.classList.remove('swiper-wrapper')

		if (productsGridSwiper) {
			productsGridSwiper.destroy(true, true)
			productsGridSwiper = null
		}
	}

	const mount = (section) => {
		if (!section || !section?.classList.contains('products-grid-section'))
			return

		// Tear down any previous instance so we don't leak observers / Swipers
		// across content swaps (dynamic load, theme editor reload).
		if (sectionResizeObserver) {
			sectionResizeObserver.disconnect()
			sectionResizeObserver = null
		}
		if (productsGridSwiper) {
			productsGridSwiper.destroy(true, true)
			productsGridSwiper = null
		}

		const slider = section.querySelector('.products-grid-slider')

		if (!slider) return

		sectionResizeObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.contentRect.width < 576 && slider) {
					if (!productsGridSwiper) initSlider(slider)
				} else if (productsGridSwiper) {
					destroySlider(section)
				}
			})
		})

		sectionResizeObserver.observe(section)
	}

	const initProductsGrid = (section) => {
		if (!section || !section?.classList.contains('products-grid-section'))
			return

		// Native products-grid.js fetches the section via the Section Rendering API
		// when data-is-dynamic-load="true" (collection > 50 products, or manual /
		// best-selling sort with a base URL). The fetch resolves AFTER our defer'd
		// script runs and replaces the inner DOM via innerHTML — which detaches
		// anything Swiper was mounted on. Wait for the loading class to lift before
		// mounting; otherwise the new DOM stays in FOUC state (cards 2..n at opacity 0).
		const dynamicBox = section.querySelector(
			'.products-grid[data-is-dynamic-load="true"]'
		)

		if (dynamicBox && dynamicBox.classList.contains('products-grid--loading')) {
			const classObserver = new MutationObserver(() => {
				if (!dynamicBox.classList.contains('products-grid--loading')) {
					classObserver.disconnect()
					mount(section)
				}
			})
			classObserver.observe(dynamicBox, {
				attributes: true,
				attributeFilter: ['class'],
			})
			return
		}

		mount(section)
	}

	initProductsGrid(document.currentScript.parentElement)

	document.addEventListener('shopify:section:load', function (e) {
		if (
			e.target &&
			e.target.classList &&
			e.target.classList.contains('products-grid-section')
		) {
			mount(e.target)
		}
	})
})()
